/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-pdp-reveal.js — one-shot reveal of the lower bands of the redesigned PDP.
   Same pattern as qp-rime-reveal.js, three deliberate changes:
     (a) targets only the .shopify-section elements AFTER the qp-build-main
         section inside #MainContent. NEVER the build section itself (a
         transform on an ancestor breaks the sticky buy box / gallery) and
         NEVER the section holding the pinned bar (a transform re-anchors a
         position:fixed descendant).
     (b) ONE-SHOT: `is-in` is added and never removed.
     (c) 24px translate / 800ms / 12% threshold (all in qp-build.css), html
         gate `qp-pdp-reveal-ready` set by the inline script in
         sections/qp-build-main.liquid, which also drops it after 3s when
         this file never ran (window.__qpPdpReveal).
   Inner stagger targets (each observed on its own, one-shot): the IN THE BOX
   box inside the build section (opacity-only ledger rows) and every KEY
   FEATURES row. Their stagger index is written as --qp-i. Any error drops
   the gate so the page renders its final state. */
(function (win) {
  'use strict';
  if (win.__qpPdpReveal) return;
  win.__qpPdpReveal = true;
  var doc = win.document, root = doc.documentElement, READY = 'qp-pdp-reveal-ready', io = null;

  function fail() { root.classList.remove(READY); }

  function canAnimate() {
    if (!('IntersectionObserver' in win)) return false;
    if (win.Shopify && win.Shopify.designMode) return false;
    return !(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* sections AFTER the build section, minus the one with the pinned bar */
  function targets() {
    var main = doc.getElementById('MainContent') || doc.querySelector('main');
    if (!main) return [];
    var build = null;
    var all = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    for (var k = 0; k < all.length; k++) {
      if (all[k].querySelector('qp-build-main')) { build = all[k]; break; }
    }
    if (!build) return [];
    return all.filter(function (s) {
      if (s === build) return false;
      if (!(build.compareDocumentPosition(s) & 4)) return false; /* DOCUMENT_POSITION_FOLLOWING */
      return !s.querySelector('qp-qs-bar, .qp-qs-bar, .qp-qs-closing');
    });
  }

  /* inner stagger hosts: IN THE BOX (inside the build section) + KEY FEATURES rows */
  function inner() {
    var out = [];
    Array.prototype.forEach.call(doc.querySelectorAll('qp-build-main .qp-qs__box'), function (b) {
      Array.prototype.forEach.call(b.querySelectorAll('.qp-qs__ledger-row'), function (r, i) {
        r.style.setProperty('--qp-i', String(i));
      });
      out.push(b);
    });
    Array.prototype.forEach.call(doc.querySelectorAll('.qp-qs-feat__row'), function (r) { out.push(r); });
    /* KIT STRIP (bundle gallery): its three tiles rise in on a 60ms stagger,
       one-shot. Not a lower band: it sits in the build section's gallery
       column, and only the TILES carry the transform (never an ancestor of
       the sticky gallery). The lead media is never part of this. */
    Array.prototype.forEach.call(doc.querySelectorAll('qp-build-main .qp-kit'), function (k) {
      Array.prototype.forEach.call(k.querySelectorAll('.qp-kit__tile'), function (t, i) {
        t.style.setProperty('--qp-i', String(i));
      });
      out.push(k);
    });
    /* YOUR BUILD rows stagger only on mobile, and only when the list sits
       below the fold on first paint (armed once; never on desktop) */
    if ((win.innerWidth || root.clientWidth) < 1024) {
      Array.prototype.forEach.call(doc.querySelectorAll('qp-build-main .qp-build__card-list--rows'), function (l) {
        if (!l.hasAttribute('data-qp-armed') && !l.classList.contains('is-in')) {
          l.setAttribute('data-qp-armed', '');
          if (l.getBoundingClientRect().top > (win.innerHeight || root.clientHeight)) {
            l.classList.add('is-armed');
            Array.prototype.forEach.call(l.querySelectorAll('.qp-build__card'), function (c, i) {
              c.style.setProperty('--qp-i', String(i));
            });
          }
        }
        if (l.classList.contains('is-armed')) out.push(l);
      });
    }
    return out;
  }

  /* one-shot: in once >= 12% visible, or taller than the viewport and
     overlapping at all. Never removed. */
  function apply(el, top, bottom, height) {
    var vh = win.innerHeight || root.clientHeight;
    var seen = Math.min(bottom, vh) - Math.max(top, 0);
    if (seen <= 0) return;
    if (height > vh || seen / Math.max(height, 1) >= 0.12) {
      el.classList.add('is-in');
      if (io) io.unobserve(el);
    }
  }

  function onEntries(entries) {
    try {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var r = e.boundingClientRect;
        apply(e.target, r.top, r.bottom, r.height);
      });
    } catch (err) { fail(); }
  }

  function recheck() {
    try {
      targets().concat(inner()).forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        apply(el, r.top, r.bottom, r.height);
      });
    } catch (err) { fail(); }
  }

  function init() {
    try {
      if (!canAnimate() || win.__qpPdpRevealGate === -1) { fail(); return; }
      root.classList.add(READY);
      if (!io) io = new win.IntersectionObserver(onEntries, { threshold: [0, 0.12] });
      targets().concat(inner()).forEach(function (el) {
        if (el.hasAttribute('data-qp-pdp-reveal') || el.classList.contains('is-in')) return;
        el.setAttribute('data-qp-pdp-reveal', '');
        io.observe(el);
      });
    } catch (err) { fail(); }
  }
  var t;
  win.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(recheck, 150); });
  win.addEventListener('pageshow', function () { init(); recheck(); });
  win.addEventListener('hashchange', recheck);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})(window);
